// src/state/liveBuzzStore.js
const listeners = new Set();
const recentByChain = new Map();      // chainId -> Map(address -> expiryTs)
const seenByChain = new Map();        // chainId -> Set(eventKey)
const lastBumpByChain = new Map();    // chainId -> Map(address -> lastBumpTs)

const nowMs = () => Date.now();

export const subscribeLiveBuzz = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

const notify = (chainId) => {
  for (const fn of listeners) {
    try { fn(chainId); } catch {}
  }
};

export const ingestHistory = (chainId, events, ttlMs = 6000) => {
  const cid = Number(chainId);
  const arr = Array.isArray(events) ? events : [];
  const seen = seenByChain.get(cid) || new Set();
  if (!seenByChain.has(cid)) seenByChain.set(cid, seen);
  const map = recentByChain.get(cid) || new Map();
  if (!recentByChain.has(cid)) recentByChain.set(cid, map);
  const lastMap = lastBumpByChain.get(cid) || new Map();
  if (!lastBumpByChain.has(cid)) lastBumpByChain.set(cid, lastMap);
  const now = nowMs();
  let changed = false;
  for (const it of arr) {
    if (!it || (it.type !== 'bought' && it.type !== 'buy' && it.type !== 'Bought')) continue;
    const key = `${it.chainId ?? cid}:${it.contract}:${it.buyer}:${it.amount}`;
    if (seen.has(key)) continue;
    seen.add(key);
    const addr = String(it.contract || it.address || '').toLowerCase();
    if (!addr) continue;
    map.set(addr, now + ttlMs);
    lastMap.set(addr, now); // persist last bump timestamp for ordering
    changed = true;
  }
  if (changed) notify(cid);
  return changed;
};

export const getRecentMap = (chainId) => {
  const cid = Number(chainId);
  return recentByChain.get(cid) || new Map();
};

export const pruneExpired = (chainId) => {
  const cid = Number(chainId);
  const map = recentByChain.get(cid);
  if (!map) return false;
  const now = nowMs();
  let changed = false;
  for (const [addr, exp] of Array.from(map.entries())) {
    if (exp <= now) { map.delete(addr); changed = true; }
  }
  if (changed) notify(cid);
  return changed;
};

export const getLastBumpMap = (chainId) => {
  const cid = Number(chainId);
  return lastBumpByChain.get(cid) || new Map();
};